import { fetchOptions } from './csrf'

export interface VideoSetting {
  id: string | null
  provider: string
  youtube_channel_id: string | null
  youtube_channel_name: string | null
  youtube_connected: boolean
  auto_upload_enabled: boolean
  created_at: string | null
  updated_at: string | null
}

interface VideoSettingResponse {
  video_setting: VideoSetting
}

interface ErrorResponse {
  errors: string[]
}

export const videoSettingsApi = {
  async show(): Promise<VideoSetting> {
    const response = await fetch('/api/v1/settings/video', fetchOptions())
    if (!response.ok) throw new Error('Failed to load video settings')
    const data: VideoSettingResponse = await response.json()
    return data.video_setting
  },

  async update(params: { provider?: string; auto_upload_enabled?: boolean }): Promise<VideoSetting> {
    const response = await fetch('/api/v1/settings/video', {
      ...fetchOptions('PUT'),
      body: JSON.stringify({ video_setting: params }),
    })
    if (!response.ok) {
      const data: ErrorResponse = await response.json().catch(() => ({ errors: ['Failed to update settings'] }))
      throw new Error(data.errors.join(', '))
    }
    const data: VideoSettingResponse = await response.json()
    return data.video_setting
  },

  async disconnectYoutube(): Promise<VideoSetting> {
    const response = await fetch('/api/v1/settings/video/youtube', fetchOptions('DELETE'))
    if (!response.ok) throw new Error('Failed to disconnect YouTube')
    const data: VideoSettingResponse = await response.json()
    return data.video_setting
  },
}
